var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.22 8.13333V5.13421L25.2191 9.13333H22.22C21.6677 9.13333 21.22 8.68562 21.22 8.13333ZM28.5 10.1333C28.5 10.1109 28.4993 10.0886 28.4978 10.0666C28.5162 9.78893 28.4193 9.50509 28.2071 9.29289L21.2071 2.29289C20.9762 2.06199 20.6605 1.96761 20.3602 2.00976C20.3144 2.00333 20.2676 2 20.22 2H5.50004C4.94776 2 4.50004 2.44772 4.50004 3V16V25L4.5 29C4.49999 29.5523 4.94771 30 5.5 30H9.50003H17.5V28H9.50003H6.50001L6.50004 25V16V4H19.22V8.13333C19.22 9.79019 20.5631 11.1333 22.22 11.1333H26.5V18H28.5V10.1333Z",
    fill: "#636B74"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23.5,
    r: 7.5,
    stroke: "#636B74",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18L28.5 29",
    stroke: "#636B74",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopped);
export default __webpack_public_path__ + "static/media/stopped.89203a03c1221ec96b27c006bcd893eb.svg";
export { ForwardRef as ReactComponent };